/*
LoginPageView
*/

import React from 'react';
import { Navigate, useNavigate  } from "react-router-dom";
import { globals, authent_form, traceView} from '../Components/Globals/Globals';
import {DsAdminAuthent} from "datasync-admin-authent"
import { useDispatch, useSelector } from 'react-redux';
import { loginSuccess, loginFailure, logout } from '../redux/authSlice';
import {Button} from "reactstrap";
import axios from 'axios';
import {openModalAbout} from "../redux/modalSlice"

const LoginPageView = () => {
    const fake_user = {"version":"Debug","current_user":{"data_guid":"98cabcb6-7f44-4b6c-94bc-1e95c27b9837",data_blob:{data_tier:{"e_mail":"pmabiala@me.com", "admin":"Oui"}}}}
    const dispatch = useDispatch()
    let navigate = useNavigate()
    let {isAuthenticated} = useSelector((state) => state.auth);

    traceView("LoginPageView");

    React.useEffect(() => {
        let isMounted = true

        //Automatically redirect to Admin console page as all data are loaded
        if (
            isAuthenticated 
        ){
            //Loading is done, the redirect to the landing page
            if (globals.parameters.debugging)
                console.log("LoginView.js::loading done...")
            navigate("/userlounge");//Back to authent page
        }

        // Cleanup function
        return () => {
            isMounted = false
        }
    }, [isAuthenticated, dispatch]);

    const onAdminConnectHandler = async (p_current_user) => {

        try {
            console.log("onAdminConnectHandler :: email authentified ", p_current_user)

            //Retrieve user account data from database
            axios.defaults.headers.get['Access-Control-Allow-Origin'] = '*';
            const cdlpAccount = await axios.post(globals.get_user_account_endpoint.url, p_current_user);

            if (globals.parameters.debugging)
                console.log("onAdminConnectHandler:: account found in Database ->", cdlpAccount)

            if (!cdlpAccount.data.state)
                throw(cdlpAccount.data.message)

            //Fix tel number with +33 prefix
            try {
                if (globals.parameters.debugging)
                    console.log("tel before correction ->", cdlpAccount.data.items[0].tel)

                if (cdlpAccount.data.items[0].tel[0] == "0")
                    cdlpAccount.data.items[0].tel = "+33" + cdlpAccount.data.items[0].tel.substr(1)

                if (globals.parameters.debugging)
                    console.log("tel after correction ->", cdlpAccount.data.items[0].tel)
            }
            catch(err){
                cdlpAccount.data.items[0].tel = ""
            }
            


            dispatch(loginSuccess(cdlpAccount.data.items[0]));//Call reducer
    
        } catch (error) {
            console.error("Error fetching user account data:", error);
            alert("Erreur lors de la récupération des données du compte utilisateur.");
        }
        //navigate("/authent")
    }
    
    //rendering
    return (
        <div className="login-page-container">
            {/* Full width main picture */}
            <div className="top-banner-image">
                <div className="nested-title">Mon compte</div>
            </div>

            <div className="body-page-container">
                {/* Welcome Panel */}
                <div className="welcome-title">
                    <div>
                    Connexion à votre compte
                    </div>
                </div>

                {/* Laïus introduction de la page*/}
                <div className="introduction-container">
                    <p><strong>Nouveau !</strong> Pour déposer ou consulter vos requêtes, il est nécessaire d'authentifier votre compte mail.
                    <br/>Votre adresse email ne vous sera plus demandée jusqu'à votre prochaine connexion.
                    <br/></p>
                    <ol>
                        <li>Entrez votre adresse mail ci-dessous.</li>
                        <li>Saisissez le résultat de l'opération <b>(ex: 0 + 1 = 1)</b> dans le champ suivant afin de vérifier que vous n'êtes pas un robot.</li>
                        <li>Cliquez le bouton soumettre</li>
                        <li>Nous vous envoyons un code à 6 chiffres dans la boîte mail que vous nous aurez indiquée.</li>
                        <li>Enfin nous vous demandon de nous la fournir pour vous authentifier</li>
                    </ol>
                </div>

                <DsAdminAuthent 
                    form = {authent_form}
                    email_check_only = {true}
                    obsolete_filter_format = {false}
                    datasync_url = {globals.datasync_service.url}
                    mailsync_url = {globals.mailsync.url}
                    token_email_display_sender = "ne-pas-repondre@jesusestlareponsepourtous.org"
                    subject = {"Demande de connexion au compte JLRPT.com"}
                    /*
                    company_guid = {"4"}
                    table_guid= {globals.datasync.admin_users_table_guid}*/
                    allow_spaces_in_json={globals.parameters.production}
                    beforeAdminGranted={(p_o_user_data_block)=>{
                                            try{
                                                console.log (`${p_o_user_data_block.data_blob.data_tier.e_mail} has requests access`)
                                                return (p_o_user_data_block.data_blob.data_tier.enabled == "Oui")
                                            }
                                            catch(e){
                                                alert(`beforeAdminGranted raises error ${e}`)
                                                console.error(`beforeAdminGranted raises error ${e}`)
                                            }
                                        }}
                    onAdminFailed = {(p_error_object) => {alert(`Authentication error raised with error_code:${p_error_object.code} and message:${p_error_object.msg}`)}}
                    onAdminGranted={(record)=>{onAdminConnectHandler(record);}}
                    onPartnerGranted={null}/>                
            </div>
            {globals.parameters.debugging && 
            <>
                <Button className='btn-success' onClick={()=>{onAdminConnectHandler({email:"  PMAbiala@me.com  "});}}>Connexion</Button>
                <Button className='btn-success' onClick={()=>{dispatch(openModalAbout())}}>Dialog</Button>
            </>}
        </div>
        );
}

export default LoginPageView;